<template>
  <div class="v2026-chiprow" v-if="items.length">
    <span class="v2026-chiprow__label">{{ label }}</span>
    <div class="v2026-chiprow__row">
      <span class="v2026-chiprow__chip" v-for="(item, index) in items" :key="index">{{ item }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'chip-row-v2026',
  props: {
    label: {
      type: String,
      required: true
    },
    items: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style scoped>
.v2026-chiprow {
  --v2026-chiprow-main-soft: #31C1D714;
  --v2026-chiprow-border: #e4e7ec;
  --v2026-chiprow-text: #101828;
  --v2026-chiprow-text-secondary: #667085;

  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 0 16px;
}

.v2026-chiprow__label {
  font-size: 13px;
  font-weight: 600;
  color: var(--v2026-chiprow-text-secondary);
}

.v2026-chiprow__row {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.v2026-chiprow__chip {
  display: inline-flex;
  align-items: center;
  padding: 4px 12px;
  border-radius: 999px;
  background: var(--v2026-chiprow-main-soft);
  color: var(--v2026-chiprow-text);
  font-size: 12px;
  border: 1px solid var(--v2026-chiprow-border);
}
</style>
